import PartnerTemplate from '../components/marketing/PartnerTemplate';

/* GNA Advisors × Clarid — consulting partner (dual lockup). Advisory + AI-native platform. */
export default function GNAPartnerPage() {
  return (
    <PartnerTemplate
      docTitle="GNA Advisors + Clarid — Banker-Built Advisory Meets AI-Native Compliance"
      lockup="dual"
      partnerName="GNA Advisors"
      partnerLogo="/gna-logo.svg"
      eyebrow="§ PARTNERSHIP · GNA ADVISORS × CLARID"
      headline={<>Banker-built advisory meets <span className="frame-quote">AI-native compliance.</span></>}
      lead="GNA Advisors is the firm built by bankers, for bankers — leading community and regional banks through mergers, conversions, and operational transformation with decades of first-chair banking experience. Clarid is the AI-native compliance platform that operationalizes expert recommendations into continuous, automated monitoring. Together — advisory depth with the technology layer that sustains it through every change event."
      thesisKicker="§ 01 · WHY THIS PARTNERSHIP"
      thesisHeadline="Strategic change is where compliance programs are tested."
      thesis={[
        {
          well: '01',
          title: 'Recommendations that keep running',
          body: "GNA's advisory recommendations get operationalized into continuous, automated monitoring — so the program holds long after the engagement ends.",
        },
        {
          well: '02',
          title: 'Compliance that survives change events',
          body: 'Mergers, core conversions, and charter changes are where programs fall behind. Clarid keeps marketing, HMDA, fair lending, and CRA current through every transition.',
        },
        {
          well: '03',
          title: 'Same DNA, two layers',
          body: 'Banker-built advisory and an examiner-validated platform — the depth GNA brings to the boardroom, sustained day to day in the product.',
        },
      ]}
      bringsHeadline="The technology layer under expert advice."
      depth={[
        { label: 'Marketing & policy', txt: 'Marketing-compliance review and program / policy management, kept current against regulatory change.' },
        { label: 'HMDA & fair lending', txt: '170+ edit checks, IFLEP fair-lending risk factors, and regression reproducing the FRB tool to the decimal.' },
        { label: 'CRA & exam', txt: 'CRA assessment-area analysis and continuous exam-readiness scoring with one-click examiner packages.' },
      ]}
      proofs={[
        { stat: '170+ HMDA edit checks', desc: 'Full LAR validation against the current edit-check set.' },
        { stat: 'FRB Fair Lending Tool — to the decimal', desc: "Clarid reproduces the Federal Reserve's fair-lending methodology exactly, not an approximation." },
        { stat: 'Deterministic · multi-provider', desc: "Circuit-breaker fallback across providers — it kept running through Anthropic's largest-ever outage. SHA-256-verified exam packages." },
      ]}
      integration={{
        kicker: '§ 03 · HOW IT WORKS TOGETHER',
        headline: 'Advice, operationalized.',
        lead: 'GNA sets the strategy through a change event; Clarid operationalizes it into continuous monitoring that holds between engagements.',
        barLabel: 'gna.advisory → clarid.platform → continuous',
        flow: [
          { name: 'GNA · advisory', sub: 'Mergers · conversions · transformation' },
          { name: 'Clarid · platform', sub: 'Continuous marketing, HMDA, fair-lending & CRA monitoring', clarid: true },
          { name: 'Sustained program', sub: 'Examiner-ready through every change' },
        ],
        tags: [
          { label: '✓ Marketing & policy · shipped', kind: 'shipped' },
          { label: '✓ Fair lending & CRA · shipped', kind: 'shipped' },
          { label: '◇ Co-delivery model · roadmap', kind: 'roadmap' },
        ],
        note: '▢ integration shape — illustrative; co-delivery mechanics scoped with GNA. Roadmap items marked as roadmap.',
      }}
      contact={{ name: 'Bobby Sloan', title: 'Founder & CEO, Clarid', email: 'bobby@clarid.ai' }}
    />
  );
}
